import { Signal } from '@angular/core';
import { IManualDeliverableStatusConfig } from '@cta-analytics-details/cta-analytics-details-deliverable-card/manual-deliverable-status/manual-devlierable-status.interface';
import { EAnalyticsStatus } from '@enums/campaign-analytics.enum';
import { IAnalyticsImage } from '@interfaces/deliverable-analytics.interface';

export enum EFindingCardSortMode {
  time = 'time',
  longestVisible = 'longestVisible',
}

export interface IFindingCardData {
  id: string;
  // Chronological position (1..n), independent of the active sort mode.
  number: number;
  // Seconds used for chronological ordering.
  sortTime: number;
  duration?: number | null;
  analyticsImage?: IAnalyticsImage | null;
  // Absolute timestamp, shown as "Real time" (streams only).
  realTime?: string | null;
  videoTimeLabel: string;
}

export interface IFindingCardSortOption {
  value: EFindingCardSortMode;
  labelKey: string;
}

export interface IFindingCardJump {
  cardId: string;
  sortMode: EFindingCardSortMode;
}

// Objective "N/1" pill + jump arrow shown next to the deliverable's objective in the analytics popup.
export interface IFindingCardsObjective {
  status: EAnalyticsStatus | null;
  findingsCount: number;
  loading: boolean;
  jump: () => void;
}

// "N findings · X visible in total" next to the graph heading; `duration` is null when nothing has one.
export interface IFindingsSummary {
  count: number;
  duration: string | null;
}

export interface IFindingCardsStateOptions<T extends IFindingCardData> {
  manualDeliverableStatusConfig: Signal<IManualDeliverableStatusConfig>;
  // Ids removed in this session or before; such cards are left out of the objective count and jump.
  removedIds: () => ReadonlySet<string>;
  isPendingDeletion: (card: T) => boolean;
  loading: () => boolean;
  status: () => EAnalyticsStatus | null;
  // Selects and reveals the card the objective jump arrow lands on.
  onJump: (cardId: string) => void;
}

export interface IFindingImageZoomDialogData {
  imageUrl: string;
  alt: string;
}
